var _mask, _path, _path2, _mask2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 18,
    width: 112,
    height: 68,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 4,
    y: 18,
    width: 112,
    height: 68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6001 46C39.3797 32.3066 51.4863 22 66 22C80.533 22 92.6524 32.3339 95.4109 46.0545C104.693 46.7741 112 54.5337 112 64C112 73.9411 103.941 82 94 82H26C16.0589 82 8 73.9411 8 64C8 54.0589 16.0589 46 26 46H36.6001Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6001 46C39.3797 32.3066 51.4863 22 66 22C80.533 22 92.6524 32.3339 95.4109 46.0545C104.693 46.7741 112 54.5337 112 64C112 73.9411 103.941 82 94 82H26C16.0589 82 8 73.9411 8 64C8 54.0589 16.0589 46 26 46H36.6001Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6001 46C39.3797 32.3066 51.4863 22 66 22C80.533 22 92.6524 32.3339 95.4109 46.0545C104.693 46.7741 112 54.5337 112 64C112 73.9411 103.941 82 94 82H26C16.0589 82 8 73.9411 8 64C8 54.0589 16.0589 46 26 46H36.6001Z",
    stroke: "white",
    strokeWidth: 8,
    mask: "url(#path-2-outside-1)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-2",
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 53,
    width: 71,
    height: 50,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 45,
    y: 53,
    width: 71,
    height: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8799 98.9989C58.3287 98.8847 49 89.5269 49 78C49 66.402 58.444 57 70.0938 57C80.2987 57 88.8111 64.2145 90.7655 73.7999H99.4C106.359 73.7999 112 79.4411 112 86.3999C112 93.3587 106.359 98.9999 99.4 98.9999H70.1567C70.1357 99 70.1147 99 70.0938 99C70.0725 99 70.0513 99 70.0301 98.9999C69.98 98.9999 69.9299 98.9996 69.8799 98.9989Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8799 98.9989C58.3287 98.8847 49 89.5269 49 78C49 66.402 58.444 57 70.0938 57C80.2987 57 88.8111 64.2145 90.7655 73.7999H99.4C106.359 73.7999 112 79.4411 112 86.3999C112 93.3587 106.359 98.9999 99.4 98.9999H70.1567C70.1357 99 70.1147 99 70.0938 99C70.0725 99 70.0513 99 70.0301 98.9999C69.98 98.9999 69.9299 98.9996 69.8799 98.9989Z",
    fill: "#CCCCCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8799 98.9989C58.3287 98.8847 49 89.5269 49 78C49 66.402 58.444 57 70.0938 57C80.2987 57 88.8111 64.2145 90.7655 73.7999H99.4C106.359 73.7999 112 79.4411 112 86.3999C112 93.3587 106.359 98.9999 99.4 98.9999H70.1567C70.1357 99 70.1147 99 70.0938 99C70.0725 99 70.0513 99 70.0301 98.9999C69.98 98.9999 69.9299 98.9996 69.8799 98.9989Z",
    stroke: "white",
    strokeWidth: 8,
    mask: "url(#path-3-outside-2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.80aed3e5592d6b25e0f1ddef7bddf955.svg";
export { ForwardRef as ReactComponent };